/**
 * Adjacent links UI component
 * @param  data 
 * @returns 
 * data : Array
 * sidebarLinks : array
 * adjacentlink.uri : string
 * adjacentlink.title : string
 *  
 */ 
 import React from "react"
 //import { Link } from "gatsby"
 var _ = require('lodash');
 function SidebarAdjacentLinks(data) {
 
  if((!_.isNil(data)) && (!_.isNil(data.data))) {
       const adjacentLinks = data.data.sidebarLinks.map((adjacentLink, index) => {
       return (
         <li className="link-items__link" key={adjacentLink}>
           <a href={adjacentLink[1].uri}>{adjacentLink[1].title}</a>
         </li>
       )
   }
   );
   return(
     <div className="adjacentlinks">
       <div className="element--inner">
        <p><a href={data.data.sidebarHeader.sidebarLink} className="heading contact-links__heading underline-link">{data.data.sidebarHeader.sidebarTitle}</a></p>
         <nav role="navigation" aria-label="Pages in this section">
           <ul className="link-items">
             {adjacentLinks}
           </ul>
         </nav>  
       </div>
     </div>
   )
  } else {
    return null
  }
   
 }
 export default SidebarAdjacentLinks